import { SyncIcon } from '@primer/octicons-react'

import Button from '../common/Button/Button'
import Icon from '../common/icons/Icon'
import PackageIcon from '../common/icons/PackageIcon'

import { text } from '../../constants/colors.constants'

const buttonStyle = {
  border: 'none',
  background: '#FFFFFF',
  boxShadow: 'none',
  paddingTop: '.5rem'
}

export const PublishStateIcons = ({ 
  engineConfig, 
  modelConfigIds, 
  pipelineVersionId,
  status,
  publishRequest
}) => {

  if (status === 'Publishing') {
    return (
      <Button sx={buttonStyle}>
        <SyncIcon size={16} fill={text.mainBlue}/>
      </Button>
    )
  }

  return (
    <Button onClick={() => publishRequest(engineConfig, modelConfigIds, pipelineVersionId)} sx={buttonStyle} disabled={status === 'Published'}>
      <Icon icon={PackageIcon} size={48} />
    </Button>
  )
}

export default PublishStateIcons
